// actions
const SET = 'itemConsumption/SET';
const SET_SELECTED = 'itemConsumption/SET_SELECTED';
const SET_NEXT_TOKEN = 'itemConsumption/SET_NEXT_TOKEN';
const SET_FILTER = 'itemConsumption/SET_FILTER';

const DEFAULT_STATE = {
  listing: [],
  searchText: '',
  selected: '',

  nextToken: null,
  nextNextToken: undefined,
  previousTokens: [],
  filter: [],
};

// reducer
const reducer = (state = DEFAULT_STATE, action: any = {}) => {
  switch (action.type) {
    case SET:
      return Object.assign({}, state, { listing: action.listing });
    case SET_SELECTED:
      return Object.assign({}, state, { selected: action.id });
    case SET_NEXT_TOKEN:
      return Object.assign({}, state, { nextToken: action.id });
    case SET_FILTER:
      return Object.assign({}, state, { filter: action.id });
    default:
      return state;
  }
};

export default reducer;

// action creators
export const setListing = (listing: any[]) => ({ listing, type: SET });
export const setSelected = (id: string) => ({ id, type: SET_SELECTED });
export const setNextToken = (id: any) => ({ id, type: SET_NEXT_TOKEN });
export const setFilter = (id: any) => ({ id, type: SET_FILTER });
